// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2nc0U","productName":"Table_productName__3a7OQ"};